import { getTimeSetup, id } from "./utils";

export function getSetupFromURL(urlParams, setup) {
  let isExpanded = false;
  if (urlParams.has("t")) {
    if (urlParams.has("id")) {
      setup.id = urlParams.get("id");
    }
    switch (urlParams.get("t").toLowerCase()) {
      case "tabata":
        if (urlParams.has("s")) {
          setup.sets = urlParams.get("s");
          if (urlParams.has("w")) {
            setup.work = getTimeSetup(urlParams.get("w"));
          }
          if (urlParams.has("r")) {
            setup.rest = getTimeSetup(urlParams.get("r"));
          }
        } else {
          isExpanded = true;
          if (urlParams.has("p")) {
            setup.expanded.prepare = getTimeSetup(urlParams.get("p"));
          }
          if (urlParams.has("c")) {
            setup.expanded.cooldown = getTimeSetup(urlParams.get("c"));
          }
          if (urlParams.has("n")) {
            setup.expanded.name = urlParams.get("n");
          }
          if (urlParams.has("d")) {
            setup.expanded.description = urlParams.get("d");
          }

          if (urlParams.has("r")) {
            const rounds = urlParams.getAll("r");

            setup.expanded.rounds = rounds.map((r) => ({
              id: id(),
              name: r.split(";")[0],
              title: "",
              work: getTimeSetup(r.split(";")[1]),
              rest: getTimeSetup(r.split(";")[2]),
            }));
          }
        }
        break;
      case "emom":
        if (urlParams.has("s")) {
          setup.sets = urlParams.get("s");
          if (urlParams.has("w")) {
            setup.work = getTimeSetup(urlParams.get("w"));
          }
        } else {
          isExpanded = true;
          if (urlParams.has("p")) {
            setup.expanded.prepare = getTimeSetup(urlParams.get("p"));
          }
          if (urlParams.has("c")) {
            setup.expanded.cooldown = getTimeSetup(urlParams.get("c"));
          }
          if (urlParams.has("n")) {
            setup.expanded.name = urlParams.get("n");
          }
          if (urlParams.has("d")) {
            setup.expanded.description = urlParams.get("d");
          }

          if (urlParams.has("r")) {
            const rounds = urlParams.getAll("r");

            setup.expanded.rounds = rounds.map((r) => ({
              id: id(),
              name: r.split(";")[0],
              title: "",
              work: getTimeSetup(r.split(";")[1]),
            }));
          }
        }
        break;
      case "amrap":
        if (urlParams.has("r")) {
          isExpanded = true;
          if (urlParams.has("p")) {
            setup.expanded.prepare = getTimeSetup(urlParams.get("p"));
          }
          if (urlParams.has("c")) {
            setup.expanded.cooldown = getTimeSetup(urlParams.get("c"));
          }
          if (urlParams.has("n")) {
            setup.expanded.name = urlParams.get("n");
          }

          if (urlParams.has("r")) {
            const round = urlParams.get("r");
            const amrapRound = {
              work: getTimeSetup(round),
              description: urlParams.has("d") ? urlParams.get("d") : "",
            };
            setup.expanded.rounds.push(amrapRound);
          }
        } else {
          if (urlParams.has("w")) {
            setup.work = getTimeSetup(urlParams.get("w"));
          }
        }
        break;
      case "rft":
        if (urlParams.has("p")) {
          isExpanded = true;
          setup.prepare = getTimeSetup(urlParams.get("p"));
          setup.isExpanded = true;

          if (urlParams.has("n")) {
            setup.name = urlParams.get("n");
          }

          if (urlParams.has("d")) {
            const description = urlParams.get("d");
            setup.description = description;
          }
        }
        break;
    }
  }
  return isExpanded;
}
